const rouConfig = [
  {
    path: 'dashboard',
    name: 'dashboard',
    meta: {
      name: '台位',
    },
    component: () => import('./index')
  },
 

];

export default rouConfig;